import { Api } from '@blink/components';
import { Centrifuge } from 'centrifuge';

export const CentrifugeApi = new Centrifuge(Api.ARKIS_PORTAL_WS_URL as string, {
    timeout: Number(Api.WS_RPC_TIMEOUT_SECS as string) * 1000,
});
